import React from 'react';
import { ReactComponent as Globe } from './globe.svg';
//
const LoadingPage = ({ text }: { text: string }) => {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px solid rgb(0,0,0,0.1)',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Globe />
        <div style={{ width: '100%', textAlign: 'center', paddingTop: '8px' }}>
          {text}
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;
